import { css } from "@emotion/css";
import { CopyToClipboardButton } from "@octopusdeploy/design-system-components";
import { TagOffIcon, CopyIcon } from "@octopusdeploy/design-system-icons";
import { colorScales, borderRadius, space } from "@octopusdeploy/design-system-tokens";
import cn from "classnames";
import type * as React from "react";
import { useOctopusTheme } from "../Theme";
import { useThemePaletteType } from "../Theme/useThemePaletteType";
import Chip from "./Chip";
import { ChipIconWrapper } from "./ChipIconWrapper";
import type { CommonChipProps } from "./types";
type CopyToClipboardChipProps = {
    text: string;
    onClick?: () => void;
} & CommonChipProps;
export function CopyToClipboardChip(props: CopyToClipboardChipProps): React.ReactElement | null {
    const { onClick, ...otherProps } = props;
    const theme = useOctopusTheme();
    const palette = useThemePaletteType();
    const isDarkTheme = palette === "dark";
    const styles = {
        chipContainer: css({
            ".MuiChip-root": {
                cursor: "pointer",
            },
            ".MuiChip-label": {
                paddingRight: space[2],
            },
        }),
        copyToClipboardContentContainer: css({
            display: "flex",
            alignItems: "center",
        }),
        copyToClipboardButton: css({
            marginLeft: space[12],
            width: "20px",
            height: "20px",
            borderRadius: borderRadius.circle,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: isDarkTheme ? colorScales.grey["300"] : colorScales.grey["600"],
            color: theme.chipBackground,
        }),
    };
    return (<div className={styles.chipContainer}>
            <CopyToClipboardButton value={props.text} showHoverTooltip={true} onClick={props.onClick}>
                <Chip noTooltip={true} icon={<ChipIconWrapper>
                            <TagOffIcon size={16}/>
                        </ChipIconWrapper>} {...otherProps}>
                    <div className={cn(styles.copyToClipboardContentContainer)}>
                        {props.text}
                        <div className={cn(styles.copyToClipboardButton)}>
                            <CopyIcon size={16}/>
                        </div>
                    </div>
                </Chip>
            </CopyToClipboardButton>
        </div>);
}
